'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { pageTitleFromPathname } from '@/lib/page-title';

export function PageTitleUpdater() {
  const pathname = usePathname();

  useEffect(() => {
    document.title = pageTitleFromPathname(pathname);
  }, [pathname]);

  return null;
}
